/**
 * Test IDs for QA automation.
 */
export const testIds = {
  reasonCodeModalReason: "reason-code-modal-reason",
  reasonCodeModalCancel: "reason-code-modal-cancel",
  reasonCodeModalSave: "reason-code-modal-save",
} as const;
